
import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/pathObj'
import Pagination from '../../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import HiringList from './HiringList'
import helpers from 'utils/helpers'
import OSearch from 'components/reusable/OSearch'

function Hiring () {
  const { t } = useTranslation()
  const { logoutUser, user, updatePageName } = useContext(AuthContext)
  const navigate = useNavigate()

  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [forms, setForms] = useState([])
  const [item, setItem] = useState('')
  const [page, setPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [pageSize] = useState(10)

  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    category: '',
    searchKey: '',
    isFilter: false,
    isReset: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handlePageUpdate = data => {
    if (
      (data?.deletePage && forms?.length >= 1) ||
      (filterData.isFilter &&
        filterData.category &&
        data?.statusChange &&
        forms?.length >= 1)
    ) {
      if (forms?.length >= 1) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }
    }
  }

  const setFormData = (response, resultStatus) => {
    setForms(response?.docs)
    setPaginationObj({
      ...paginationObj,
      page: resultStatus ? response?.page : null,
      perPageItem: resultStatus ? response?.docs?.length : null,
      pageCount: resultStatus ? response?.totalPages : null,
      totalItems: resultStatus ? response?.totalDocs : null
    })
  }

  const getForms = async data => {
    try {
      const { startDate, endDate, category, searchKey } = filterData

      handlePageUpdate(data)

      const payload = {
        categoryType: category,
        page,
        pageSize,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchKey,
        categoryType: 'hiring',
        sortBy: sort.sortBy,
        sortType: sort.sortType,
        createdBy: user?.companyID || ''
      }

      const path = apiPath.getForms
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        // console.log('Response:', response)
        setFormData(response, resultStatus)
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handleSearchKey = e => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true })
    setPage(1)
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleFormsView = (formId) => {
    navigate("/forms-manager/view", { state: { id: formId } });
  };

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
      const timeoutId = setTimeout(() => {
        setDebouncedSearchTerm(searchTerm);
      }, 500);
      return () => {
        clearTimeout(timeoutId);
      };
    }, [searchTerm]);

  useEffect(() => {
    updatePageName(t('FORMS_MANAGER'))
  }, [])

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage,
    });
  }, [debouncedSearchTerm]);

  useEffect(() => {
    getForms()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      startDate: '',
      endDate: '',
      category: '',
      searchKey: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm("");
  }

  const handleAddHiring = () => {
    navigate('/forms-manager/addhiring');
  };

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='py-4 px-3 '>
          <div className='rounded-lg bg-white border border-[#E9EDF9] '>
            <form className='lg:grid border-b border-b-[#E3E3E3] grid 2xl:grid-cols-3 xl:grid-cols-2 lg:grid-cols-1 gap-2 px-4 py-3'>
              <div className='flex-wrap col-span-3 flex items-center'>
                <div className='flex-wrap flex items-center lg:pt-0 pt-3 mb-2'>
                  <div className='mb-3 relative flex items-center '>
                    <div className='pl-3 mr-3 absolute inset-y-0 right-0 flex items-center pointer-events-none'>
                      {!filterData?.searchKey && (
                        <svg
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                          xmlns='http://www.w3.org/2000/svg'
                          aria-hidden='true'
                          className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                          fill='none'
                        >
                          <path
                            strokeWidth='2'
                            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      )}
                    </div>
                    <OSearch setSearchTerm={setSearchTerm} placeholder={t("SEARCH_BY_TITLE")} searchTerm={searchTerm} />
                  </div>
                  <ODateRangePicker
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                    handleDateChange={handleDateChange}
                  />
                  <button
                    onClick={handleReset}
                    className='rounded-lg items-center border bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                    type='button'
                  >
                    {t('O_RESET')}
                  </button>
                  <button
                    onClick={handleAddHiring}
                    className='rounded-lg items-center border bg-LightBlue text-sm px-8 ml-3 mb-3 py-2 border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                    type='button'
                  >
                    {t('O_ADD')}
                  </button>
                </div>
              </div>
            </form>
            <HiringList
              forms={forms}
              user={user}
              getForms={getForms}
              handleFormsView={handleFormsView}
              page={page}
              setSort={setSort}
              sort={sort}
              item={item}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Hiring